import * as React from 'react';
import { useState, useEffect } from 'react';
import {
  Box,
  Stack,
  Container,
  Typography,
  Snackbar,
  Alert,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  IconButton,
  Pagination,
  CircularProgress,
  PaginationItem,
  ToggleButtonGroup,
  ToggleButton
} from '@mui/material';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Link as RouterLink } from 'react-router-dom';

//components
import Page from '../../components/Page';
import Iconify from 'src/components/Iconify';

//icons
import { ArrowBack } from '@mui/icons-material';
import { api } from 'src/Api';
import moment from 'moment';
import { NumericFormat } from 'react-number-format';
import Searchbar from 'src/layouts/dashboard/Searchbar';
import { LoadingButton } from '@mui/lab';

export default function ShipmentRequest() {
  const navigate = useNavigate();
  const location = useLocation();
  const { shipment_id } = location.state || {};

  const [requestList, setRequestList] = useState([]);
  const [loadingRequest, setloadingRequest] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const [searchLoading, setsearchLoading] = useState(false);
  const [search, setsearch] = useState('');

  const [pagesCount, setpagesCount] = useState(1);
  const [page, setPage] = useState(1);

  useEffect(() => {
    handleGetBidRequest(page);
  }, [page]);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  useEffect(() => {
    if (search.length == 0) {
      requestList.length = 0;
      handleGetBidRequest(page);
    }
  }, [search]);

  const handlePageChange = (event, value) => {
    requestList.length = 0;
    setPage(value);
    handleGetBidRequest(value);
  };

  function handleGetBidRequest(page) {
    setloadingRequest(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    const queryParams = new URLSearchParams();
    search.length > 0 && queryParams.append('search', search);
    shipment_id && queryParams.append('id', shipment_id);
    page && queryParams.append('page', page);

    fetch(`${api.get_shipment_bid_request}?${queryParams.toString()}`, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200) {
          setRequestList(result.data);
          result?.count ? setpagesCount(Math.ceil(result?.count / 10)) : setpagesCount(1);
          setloadingRequest(false);
          setsearchLoading(false);
        } else {
          setRequestList([]);
          setpagesCount(0);
          setloadingRequest(false);
          setsearchLoading(false);
        }
      })
      .catch((error) => {
        console.log('error', error);
        setloadingRequest(false);
        setsearchLoading(false);
      });
  }

  const handleChangeStatus = (id, statyyys) => {
    const myHeaders = new Headers();
    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    var formdata = new FormData();

    formdata.append('id', id);
    formdata.append('status', statyyys == 'Accepted' ? 8 : 9);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(api.action_on_bid_request, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200) {
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          setRequestList([]);
          handleGetBidRequest();
        } else {
          setSnackbarMessage(result.error);
          setSnackbarSeverity('error');
        }
        setSnackbarOpen(true);
      })
      .catch((error) => {
        console.log('error', error);
        setSnackbarMessage('An error occurred while saving.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      });
  };

  const handleStatusChange = (index, newStatus) => {
    setRequestList((prevList) => {
      const updatedList = [...prevList];
      const customer = updatedList[index];
      // Update status in the local state
      customer.status = newStatus;
      // Call API to update status on the server
      handleChangeStatus(customer.id, newStatus);
      return updatedList;
    });
  };

  return (
    <Page title={`Shipment Requests | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="flex-start" mb={2}>
          <IconButton
            style={{
              marginRight: 12,
              height: 40,
              width: 70,
              borderRadius: 5,
              backgroundColor: 'rgba(209,209,209,0.3)'
            }}
            onClick={() => navigate(-1)}
          >
            <Iconify icon="ion:return-up-back" style={{ fontSize: 25, color: '#010f58' }} />
          </IconButton>
          <Typography variant="h4" sx={{ color: '#010f58' }}>
            Shipment Request
          </Typography>
        </Stack>

        <Box
          style={{
            flexDirection: 'column',
            display: 'flex',
            flex: 1,
            marginTop: 10
          }}
          className="top_column"
        >
          <Box
            style={{
              flexDirection: 'row',
              display: 'flex',
              flex: 1
            }}
            className="top_column"
          >
            <Searchbar
              width={'100%'}
              fullWidth
              setFunction={(val) => {
                setsearch(val);
              }}
              className="width_full_property"
              placeholder={'Search Requests'}
              onEnter={() => {
                setsearchLoading(true);
                requestList.length = 0;
                handleGetBidRequest();
              }}
            />
            <LoadingButton
              style={{ width: '15%', marginLeft: '2.5%' }}
              variant="contained"
              className="width_full_status"
              loading={searchLoading}
              onClick={() => {
                setsearchLoading(true);
                setPage(1);
                handleGetBidRequest(1);
              }}
            >
              <Iconify icon="material-symbols:search" sx={{ width: 25, height: 25 }} />
            </LoadingButton>
          </Box>
        </Box>

        {/* Content */}
        <TableContainer
          component={Paper}
          sx={{ boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)', mt: 2, mb: 2 }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>NAME</TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>RATE</TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>AGE</TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>PICK UP</TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>TRIP</TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>EQUIPMENT</TableCell>
                {/* <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>RATE</TableCell> */}
                <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>STATUS</TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>ACTION</TableCell>
              </TableRow>
            </TableHead>

            {!loadingRequest && (
              <TableBody>
                {requestList.map((val, index) => (
                  <TableRow key={index}>
                    <TableCell align="left">
                      <Typography
                        style={{
                          fontSize: '12px',
                          overflow: 'hidden',
                          display: '-webkit-box',
                          WebkitBoxOrient: 'vertical',
                          WebkitLineClamp: 2,
                          width: '150px'
                        }}
                      >
                        {val?.requested_by}
                      </Typography>
                    </TableCell>
                    <TableCell align="left">
                      <Typography style={{ fontSize: 12 }}>{val?.amount}</Typography>
                    </TableCell>
                    <TableCell align="left">
                      <Typography style={{ fontSize: 12, width: 20 }}>
                        {val?.booking?.age}
                      </Typography>
                    </TableCell>

                    <TableCell align="left">
                      <Typography style={{ fontSize: 12, width: 75 }}>
                        {moment(val?.booking?.pickup_earliest).format('MM/DD/YYYY')} -{' '}
                        {moment(val?.booking?.pickup_lattest).format('MM/DD/YYYY')}
                      </Typography>
                    </TableCell>

                    <TableCell
                      align="left"
                      sx={{
                        fontSize: '12px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'flex-start'
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          justifyContent: 'flex-start'
                        }}
                      >
                        <p
                          style={{
                            fontWeight: 'bold',
                            color: '#010f58',
                            marginRight: 5,
                            fontSize: 10
                          }}
                        >
                          {val?.booking?.total_mil || '-'}
                        </p>
                        <div>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'flex-start',
                              marginBottom: -5
                            }}
                          >
                            <div
                              style={{
                                height: 6,
                                width: 6,
                                borderRadius: 100,
                                backgroundColor: 'white',
                                border: '2px solid #010f58',
                                marginRight: 5
                              }}
                            ></div>
                            <p
                              style={{
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                maxWidth: '150px' // Adjust this width as needed
                              }}
                            >
                              {val?.booking?.location_origin}
                            </p>
                          </div>
                          <div>
                            <Iconify
                              icon="mingcute:arrow-down-line"
                              style={{ fontSize: 14, marginLeft: -4.6, color: '#010f58' }}
                            />
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'flex-start',
                              marginTop: -10
                            }}
                          >
                            <div
                              style={{
                                height: 6,
                                width: 6,
                                borderRadius: 100,
                                backgroundColor: '#010f58',
                                border: '2px solid #010f58',
                                marginRight: 5
                              }}
                            ></div>
                            <p
                              style={{
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                maxWidth: '150px' // Adjust this width as needed
                              }}
                            >
                              {val?.booking?.location_destination}
                            </p>
                          </div>
                        </div>
                      </div>
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: '12px',
                        fontSize: '12px',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                      }}
                    >
                      <div style={{ display: 'flex' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', marginRight: 15 }}>
                          <p>{val?.booking?.equipment_type || '-'} </p>
                          <p>{val?.booking?.equipment_name || '-'} </p>
                        </div>
                        <div
                          style={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-end',
                            justifyContent: 'center'
                          }}
                        >
                          <p>
                            {val?.booking?.length_ft} {val?.booking?.length_unit}
                          </p>
                          <p>
                            {val?.booking?.weight_lbs} {val?.booking?.weight_unit}
                          </p>
                        </div>
                      </div>
                    </TableCell>
                    {/* 
                    <TableCell align="left" sx={{ fontSize: '12px' }}>
                      {val?.booking?.rate ? (
                        <NumericFormat
                          value={
                            val?.booking?.rate ? parseFloat(val?.booking?.rate).toFixed(2) : '0.00'
                          }
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={'$'}
                        />
                      ) : (
                        '-'
                      )}
                    </TableCell> */}

                    <TableCell align="left" sx={{ width: '120px' }}>
                      <Typography
                        className={
                          (val?.status.toLowerCase() == 'accepted' && 'status-green') ||
                          (val?.status.toLowerCase() == 'pending' && 'status-blue') ||
                          (val?.status.toLowerCase() == 'declined' && 'status-red') ||
                          (val?.status.toLowerCase() == 'deleted' && 'status-red')
                        }
                      >
                        {val?.status || 'N/A'}
                      </Typography>
                    </TableCell>

                    <TableCell align="left">
                      {val?.status.toLowerCase() == 'pending' ? (
                        <ToggleButtonGroup
                          disabled={!val?.allow_accept}
                          color="primary"
                          value={val?.status}
                          exclusive
                          onChange={(event, newStatus) => handleStatusChange(index, newStatus)}
                          aria-label="Platform"
                        >
                          <ToggleButton
                            value="Accepted"
                            sx={{
                              fontSize: '12px', // Smaller font size
                              padding: '4px 8px', // Less padding for smaller button size
                              minWidth: '80px', // Ensuring the button isn't too small
                              '&.Mui-selected': {
                                backgroundColor: 'green',
                                color: 'white'
                              }
                            }}
                          >
                            Accept
                          </ToggleButton>
                          <ToggleButton
                            value="Declined"
                            sx={{
                              fontSize: '12px', // Smaller font size
                              padding: '4px 8px', // Less padding for smaller button size
                              minWidth: '80px', // Ensuring the button isn't too small
                              '&.Mui-selected': {
                                backgroundColor: 'red',
                                color: 'white'
                              }
                            }}
                          >
                            Decline
                          </ToggleButton>
                        </ToggleButtonGroup>
                      ) : (
                        '-'
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            )}

            {/* loader */}
            {loadingRequest && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={10} sx={{ py: 3 }}>
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              </TableBody>
            )}

            {/* empty list */}
            {requestList?.length == 0 && !loadingRequest && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={8} sx={{ py: 3 }}>
                    <Box
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                      alignItems="center"
                      height="25vh"
                    >
                      <Iconify
                        icon={'bi:clipboard2-x-fill'}
                        sx={{ fontSize: 70, marginBottom: 2, color: '#010f58' }}
                      />
                      <Typography variant="h6" gutterBottom sx={{ color: '#010f58' }}>
                        You haven't any Request yet
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>

        {/* Pagination */}
        {!loadingRequest && pagesCount > 1 && requestList.length !== 0 && (
          <Box
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              marginTop: 20,
              alignItems: 'center',
              marginBottom: 20
            }}
          >
            <Pagination
              color="primary"
              shape="rounded"
              page={page}
              size="small"
              count={pagesCount}
              onChange={handlePageChange}
              renderItem={(item) => <PaginationItem {...item} />}
            />
          </Box>
        )}

        <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
          <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Container>
    </Page>
  );
}
